import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { SetSideNavVisibilityState, SideNavVisibilityState } from './visibility-context';

/**
 * Manages the side nav visibility state and provides the context.
 */
export var SideNavVisibilityProvider = function SideNavVisibilityProvider(_ref) {
  var children = _ref.children;
  // Defaults to null so we can determine if the value has been set yet (for SSR)
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    sideNavState = _useState2[0],
    setSideNavState = _useState2[1];
  return /*#__PURE__*/React.createElement(SideNavVisibilityState.Provider, {
    value: sideNavState
  }, /*#__PURE__*/React.createElement(SetSideNavVisibilityState.Provider, {
    value: setSideNavState
  }, children));
};